import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import { getSaleProducts } from "../../../../redux/saleProductActions";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import style from "./Sales.module.css";

const Sales = ({isMobile}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const products = useSelector(state => state.saleProducts.saleProducts);

    useEffect(() => {
        dispatch(getSaleProducts());
    }, [dispatch]);

    const settings = {
        arrows: false,
        dots: true, // activa los puntitos indicadores abajo
        infinite: true,
        speed: 500,
        slidesToShow: isMobile ? 1 : 3,
        slidesToScroll: 4,
        autoplay: true,           // activa autoplay
        autoplaySpeed: isMobile ? 4000 : 5000 
    };


    return(
        <div className={style.sales}>
            <p className={style.bigText}>Materiales <span>eléctricos</span> para el hogar y la industria</p>
            <div className={style.salesContainer}>
                <h2 onClick={() => navigate("/ofertas")}>Productos en oferta</h2>
                <div className={style.carrouselContainer}>
                    <Slider {...settings}>
                        {products.map((product, index) => (
                            <div key={index} className={style.slide}>
                                <a href={`https://api.whatsapp.com/send?phone=5492216954484&text=Buenos%20días,%20quisiera%20consultar%20por%20el%20producto%20en%20oferta%20${product.description}`} target="_blank" rel="noopener noreferrer">
                                    <div className={style.imageContainer}><img src={product.image} alt={product.description} /></div>
                                    <div className={style.textContainer}>
                                        <p>{product.description}</p>
                                        <p className={style.price}>${product.price.toLocaleString()}</p>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default Sales;